import React from "react";
import { CURRENCY } from "utils/constants";
import Money from "components/money";

const Price = ({ value, className = "" }) => (
    <div className={`${className} text-3xl inline-block font-bold text-[#fa621d]`}>
        <Money value={{ currencyCode: CURRENCY, amount: value }} />
    </div>
);

export default Price;
